import {fileTypeList} from './file-type-list';
import {defaultProps} from './default-props';

export {fileTypeList, defaultProps};
